import { getDaysLapsed } from '@utils/dates';
import isEmpty from '@utils/isEmpty';
import isObject from '@utils/isObject';
import { localStorageAvailable } from '@utils/localStorage';
import {
  PRACTICE_TYPE,
  TIME_LAPSE_LIMIT,
  MAX_PRACTICE_SESSION_COUNT
} from './constants';

export const conceptHasQuestions = (thresholdExceeded) => {
  return isEmpty(thresholdExceeded) ? true : thresholdExceeded;
};

export const getCardType = (type) => {
  switch (type) {
    case PRACTICE_TYPE.FULL:
      return 'Full Syllabus';

    case PRACTICE_TYPE.PYQ:
      return 'PYQ';

    case PRACTICE_TYPE.INCORRECT:
      return 'Incorrect Questions';

    default:
      return 'Topic';
  }
};

export const getSelectedType = (options, value) =>
  options.find((type) => type.value === value);

export const isDataToBeDeletedOnTimeLapse = (sessionData, goalUID) => {
  const parsedSessionData = sessionData;

  if (parsedSessionData?.[goalUID]?.timestamp) {
    const timeLapsed = getDaysLapsed(parsedSessionData[goalUID].timestamp);
    if (timeLapsed >= TIME_LAPSE_LIMIT) {
      delete parsedSessionData[goalUID];
      localStorage.setItem(
        'practiceSessionCount',
        JSON.stringify(parsedSessionData)
      );
      return false;
    }
    return true;
  }
};

export const checkIfFeedbackToBeShown = (goalUID) => {
  if (localStorageAvailable()) {
    const sessionData = localStorage.getItem('practiceSessionCount');
    if (sessionData) {
      const parsedSessionData = JSON.parse(sessionData);
      if (isObject(parsedSessionData) && parsedSessionData?.[goalUID]) {
        return isDataToBeDeletedOnTimeLapse(parsedSessionData, goalUID);
      }
    }
  }
  return false;
};

// If reminder card is viewed for more than 5 times,set the timestamp.Until the timestamp expires the reminder card will not appear in the summary section.
const updateReminderCount = (sessionData, goalUID) => {
  if (localStorageAvailable()) {
    const parsedSessionData = sessionData;
    if (parsedSessionData?.[goalUID]) {
      parsedSessionData[goalUID].count += 1;
      if (parsedSessionData[goalUID]?.count === MAX_PRACTICE_SESSION_COUNT) {
        parsedSessionData[goalUID].timestamp = new Date();
        parsedSessionData[goalUID].count = 0;
        localStorage.setItem(
          'practiceSessionCount',
          JSON.stringify(parsedSessionData)
        );
      }
    }
  }
};

export const setReminderDataToLocalStorage = (goalUID) => {
  if (localStorageAvailable()) {
    const sessionData = localStorage.getItem('practiceSessionCount');
    if (sessionData) {
      const parsedSessionData = JSON.parse(sessionData);
      if (isObject(parsedSessionData)) {
        if (parsedSessionData?.[goalUID]) {
          updateReminderCount(parsedSessionData, goalUID);
        } else {
          parsedSessionData[goalUID] = { count: 1 };
        }
        localStorage.setItem(
          'practiceSessionCount',
          JSON.stringify(parsedSessionData)
        );
      }
    } else {
      localStorage.setItem(
        'practiceSessionCount',
        JSON.stringify({ [goalUID]: { count: 1 } })
      );
    }
  }
};

// Delete the session data for the goal once reminder is set
export const deleteSessionDataForAGoalFromLocalStorage = (key, goalUID) => {
  if (localStorageAvailable()) {
    const data = localStorage.getItem(key);
    if (data) {
      const parsedData = JSON.parse(data);
      if (parsedData?.[goalUID]) {
        delete parsedData[goalUID];
        localStorage.setItem(key, JSON.stringify(parsedData));
      }
    }
  }
};
